<template>
  <div class="wrapper d-flex flex-column vh-100">
    <div :id="getId()" class="pc_main_area">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Account',
  methods: {
    getId() {
      if (this.$route.path === '/user/register') {
        return 'register'
      } else if (this.$route.path === '/user/login') {
        return 'login'
      }
    }
  }
}
</script>

<style scoped>
.main_area {
  margin: 0px;
}
.main_area .main_inner {
  margin: 0px;
}
</style>
